import { getDateFormatted } from '../../../helpers/dateService';
import Util from '../../../../../util/util';
import { DATE_SHORT_FORMAT } from '../cards/components/CardDueDate/constants';

export const getFormattedDate = (date: number, short: boolean = true, isUserTimeFormat12: boolean = false): string => {
    if (!short) return getDateFormatted(date, isUserTimeFormat12);
    return Util.formatDateMoment(new Date(date * 1000), DATE_SHORT_FORMAT)
}
